/**
 * Campaigns widget — UTM breakdown with sub-tabs (Source / Medium / Campaign).
 *
 * Uses list.build() for paginated ranked lists.
 * Sub-tab clicks re-render from cached API data (no extra fetch).
 */

import * as state from './state.js';
import { setWidgetContent, emptyState } from './table-builder.js';
import { build as listBuild } from './list.js';

/** Currently active UTM dimension. */
let activeDim = 'utm_source';

/** Labels for each dimension tab header. */
const LABELS = {
	utm_source:   'Source',
	utm_medium:   'Medium',
	utm_campaign: 'Campaign'
};

/**
 * Render the active dimension list into the widget body.
 *
 * @param {Object} data Full API response data.
 */
export function render(data) {
	const items = data[activeDim] || [];

	if (!items.length) {
		setWidgetContent('campaigns', emptyState('No UTM data yet.'));
		return;
	}

	const rows = items.map(function (item) {
		return { name: item.name, count: item.visitors };
	});

	setWidgetContent('campaigns', listBuild(LABELS[activeDim], 'Visitors', rows));
}

/**
 * Initialize sub-tab click handlers.
 * Must be called once after DOM is ready.
 */
export function init() {
	const tabs = document.querySelectorAll('[data-el="campaign-tab"]');

	tabs.forEach(function (tab) {
		tab.addEventListener('click', function () {
			const dim = tab.getAttribute('data-utm');
			if (dim === activeDim) {
				return;
			}

			activeDim = dim;

			tabs.forEach(function (t) {
				t.classList.remove('zmpa-widget-tab-active');
			});
			tab.classList.add('zmpa-widget-tab-active');

			// Re-render from cached data.
			const key = state.getRange() + '_' + state.getStartDate() + '_' + state.getEndDate();
			const cached = state.getCache(key);
			if (cached) {
				render(cached);
			}
		});
	});
}
